import { render } from "./welcomePopup.vue?vue&type=template&id=3ab3e0a3"
import script from "./welcomePopup.vue?vue&type=script&lang=js"
export * from "./welcomePopup.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/clients-dev.printpigeons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__